import { render } from "./EditSubChannelDialog.vue?vue&type=template&id=bc22051e"
import script from "./EditSubChannelDialog.vue?vue&type=script&lang=js"
export * from "./EditSubChannelDialog.vue?vue&type=script&lang=js"

import "./EditSubChannelDialog.vue?vue&type=style&index=0&id=bc22051e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__